export const SPECIAL_INSTRUCTIONS_LABEL = 'Special Instructions';
export const MODIFIERS_LABEL = 'Modifiers';
